<div class="vds-main-nav-header">
    <ng-container *polymorpheusOutlet="title() as primitive">
        {{ primitive }}
    </ng-container>
    <button vds-icon-button appearance="ghost" mode="dark" (click)="close.emit()">
        <vds-icon name="close-large" />
    </button>
</div>
<div class="vds-main-nav-content">
    <ng-content />
</div>
